var style = {"row":"GridRow-module_row__N-4gC","displayInlineFlex":"GridRow-module_displayInlineFlex__JUXPi","no-gutters":"GridRow-module_no-gutters__r8g6d","col":"GridRow-module_col__nqLNC"};

export { style as default };
//# sourceMappingURL=GridRow.module.scss.js.map
